var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 27.6,
    r: 27.6,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 55.2 55.2)",
    fill: "#2C4530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1911 28.5444C13.6696 28.0229 13.6696 27.1773 14.1911 26.6558L22.6901 18.1568C23.2116 17.6353 24.0572 17.6353 24.5787 18.1568C25.1003 18.6783 25.1003 19.5239 24.5787 20.0455L17.0241 27.6001L24.5787 35.1547C25.1003 35.6763 25.1003 36.5219 24.5787 37.0434C24.0572 37.5649 23.2116 37.5649 22.6901 37.0434L14.1911 28.5444ZM40.0645 28.9356L15.1354 28.9356L15.1354 26.2646L40.0645 26.2646L40.0645 28.9356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogleft);
export default __webpack_public_path__ + "static/media/blogleft.b1a585e5a0c297b4658ea47952048eb7.svg";
export { ForwardRef as ReactComponent };